import { LiveScoreWidgetResults } from "cdk/graphql";
import { ISport, IMLSSession } from "@sky-it-livedata/livedata-sports-design-system";

import {
  truncateNameWithDot,
  uppercaseFirstCharInText,
} from "@sky-it-livedata-libraries/livedata-commons";

import { buildGPSessionsByDate, getSessionUrl } from "../../../utils/session";

import { RaceSessionType } from "../../../types/race-session";

export enum IdayType {
  FULL,
  PARTIAL,
}

type GpInfo = ISport['gpInfo'] & { gpCrosslink: string; gpPageUrl: string };



export const getDriverName = (driver: LiveScoreWidgetResults): string =>
  driver.customDriverName && driver.customDriverSurname
    ? `${driver.customDriverSurname} ${truncateNameWithDot(
        driver.customDriverName
      )}`
    : `${uppercaseFirstCharInText(
        driver?.lastName || ""
      )} ${truncateNameWithDot(driver?.firstName?.toUpperCase() || "")}`;

export const transformSessions = (gp: ISport) => {
  return gp!.sessions?.map((session: IMLSSession) => {
    return {
      sessionName: session!.sessionName,
      sessionDate: session!.sessionDate,
      sessionStatus: session!.sessionStatus,
      sessionResultUrl:
        (gp?.gpInfo as GpInfo)?.gpPageUrl && session?.sessionName
          ? getSessionUrl(
              (gp.gpInfo as GpInfo).gpPageUrl,
              session.sessionName as RaceSessionType
            )
          : "",
      isCurrent: false,
      results: session!.results
        ? session!.results.map((driver: LiveScoreWidgetResults) => {
            const {
              customDriverPageUrl: driverUrl,
              customTeamPageUrl: teamUrl,
              fastestLap,
              flagUrl: logoUrl,
              gap,
              isFastestLap,
              position,
              timing,
              teamName,
            } = driver as LiveScoreWidgetResults;
            return {
              driverName: getDriverName(driver as LiveScoreWidgetResults),
              driverUrl,
              fastestLap,
              gap,
              isFastestLap,
              position,
              teamName,
              teamUrl,
              timing,
              logoUrl,
            };
          })
        : null,
      resultsUrl: session?.resultsUrl ?? null,
    };
  });
};

export const getTransformedDay = (params: {
  day: readonly ISport[];
  type: IdayType;
}) => {
  const { day, type } = params;

  return day!.map((gp) => {
    const transformedSessions = transformSessions(gp);

    const transformerDay: {
      gpInfo: {
        lgpLink: string | null;
        calendarUrl?: string;
        customGpName?: string;
        rankingUrl?: string;
        gpFlag?: string;
      };
      sessions: ReturnType<typeof buildGPSessionsByDate>;
      sportTag?: string;
    } = {
      gpInfo: {
        lgpLink: (gp.gpInfo as GpInfo).gpCrosslink || null,
      },
      sessions: buildGPSessionsByDate(transformedSessions || [], false),
    };

    if (type === IdayType.FULL) {
      transformerDay.gpInfo = {
        ...transformerDay.gpInfo,
        calendarUrl: gp!.gpInfo!.calendarUrl,
        customGpName: gp!.gpInfo!.customGpName,
        rankingUrl: gp!.gpInfo!.rankingUrl,
        gpFlag: gp!.gpInfo!.gpFlag,
      };

      transformerDay.sportTag = gp.sportTag;
    }

    return transformerDay;
  });
};
